angular.module('jv.Common.Resize', [])
    
.run(['$window', function($window) {
    if($window.self !== $window.top){
    	var data = {height : 525};
    	$window.parent.postMessage(angular.toJson({
                    name: 'resize',
                    data: data
                }), '*');
    }
}])


